import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./header.css";
import Logo from "./image.png";

export default function Header() {
    const role = localStorage.getItem("userRole");
    const [menuOpen, setMenuOpen] = useState(false);

    if (!role) return null;

    return (
        <header className="header">
            <div className="logo">
                <img src={Logo} alt="Logo" />
            </div>

            <div className="header-feature-notice">
                <span>✨ Nouveau</span>
                Cliquez maintenant sur un appel pour plus de détails
            </div>

            {/* BURGER (mobile uniquement) */}
            <button
                className={`burger ${menuOpen ? "open" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Menu"
            >
                <span />
                <span />
                <span />
            </button>

            <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
                <NavLink to="/depannage" onClick={() => setMenuOpen(false)}>
                    🔧 Dépannage
                </NavLink>

                {(role === "bureau" || role === "admin") && (
                    <NavLink to="/bureau" onClick={() => setMenuOpen(false)}>
                        🏢 Bureau
                    </NavLink>
                )}

                <NavLink to="/admin/archives" onClick={() => setMenuOpen(false)}>
                    📦 Archives
                </NavLink>
            </nav>
        </header>
    );
}
